import { IconComponentProps } from '../IconTypes';

const Tilde = ({ className }: IconComponentProps) => (
  <svg className={className} fill="none" height="20" viewBox="0 0 21 20" width="21" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.22371 6.84495C5.09847 6.84495 4.17552 7.75526 4.17552 8.86786V11.9022C4.17552 12.1804 3.94794 12.4079 3.66979 12.4079C3.39164 12.4079 3.16406 12.1804 3.16406 11.9022V8.86786C3.16406 7.18631 4.55165 5.8335 6.22371 5.8335C7.15298 5.8335 8.04432 6.2602 8.62275 6.99351L12.6686 12.1393C13.051 12.626 13.6484 12.9137 14.2711 12.9137C15.3932 12.9137 16.3193 12.0034 16.3193 10.8908V7.8564C16.3193 7.57825 16.5469 7.35068 16.825 7.35068C17.1032 7.35068 17.3307 7.57825 17.3307 7.8564V10.8908C17.3307 12.5723 15.9431 13.9251 14.2711 13.9251C13.3418 13.9251 12.4505 13.4984 11.872 12.7651L7.82623 7.61618C7.44377 7.12942 6.84638 6.84179 6.22371 6.84179V6.84495Z"
      fill="#646D82"
    />
  </svg>
);

export default Tilde;
